import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import styled from 'styled-components'
import { useMutation } from '@apollo/react-hooks'
import { feedbackMutations } from '../../graphql/mutations'
import { useSnackbar } from 'notistack'
import Checkbox from '@material-ui/core/Checkbox'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import Radio from '@material-ui/core/Radio'
import Divider from '@material-ui/core/Divider'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormGroup from '@material-ui/core/FormGroup'
import FormHelperText from '@material-ui/core/FormHelperText'

const DialogWrapper = styled.div`
    margin: 20px;
`

const ResearchModal = ({ isOpen, onClose, perguntas, pesquisaId, moduloId }) => {

  const [answers, setAnswers] = useState([])
  const { enqueueSnackbar } = useSnackbar()

  const [adicionaRespostasPesquisa] = useMutation(feedbackMutations.ADD_ANSWER_RESEARCH, {
    onCompleted() {
      enqueueSnackbar("Sua avaliação foi enviada com sucesso")
      onClose()
    },
  })

  const handleChangeAnswers = (e, index, tipo, altIndex) => {
    let respostas = [...answers]
    if (tipo === '2') {
      if (!respostas[index]) {
        respostas[index] = []
      }
      respostas[index][altIndex] = { nome: e.target.value, checked: e.target.checked }
    } else {
      respostas[index] = e.target.value
    }
    setAnswers(respostas)
  }

  const handleSubmit = e => {
    e.preventDefault()

     //eslint-disable-next-line
    const respostas = (perguntas || {}).map((item, index) => {

      let descricao
      let alternativa
      let multiplaEscolha = []

      if(item.tipoResposta === '1') {
        descricao = answers[index] || ''

        if (item.obrigatorio && descricao.length === 0) {
          return false
        } else {
          return {
            descricao: descricao,
            pergunta_pesquisa_id: item._id,
            enunciado: item.descricao
          }
        }
      } else if (item.tipoResposta === '2') {
        multiplaEscolha = answers[index] || []

        if (item.obrigatorio && multiplaEscolha.length !== 0) {
          const checkeds = multiplaEscolha.filter(row => row.checked)

          if (checkeds.length === 0) {
            return false
          } else {
            return {
              multiplaEscolha: multiplaEscolha,
              pergunta_pesquisa_id: item._id,
              enunciado: item.descricao
            }
          } 
        } else if (item.obrigatorio && multiplaEscolha.length === 0) {
          return false
        } else {
          return {
            multiplaEscolha: multiplaEscolha,
            pergunta_pesquisa_id: item._id,
            enunciado: item.descricao
          }
        }
      } else if (item.tipoResposta === '3') {
        alternativa = answers[index] || ''

        if (item.obrigatorio && alternativa.length === 0) {
          return false
        } else {
          return {
            alternativa: alternativa,
            pergunta_pesquisa_id: item._id,
            enunciado: item.descricao
          }
        }
      }
    })

    const canSubmit = () => {
      const temRespostasFalsas = respostas.filter(resp => resp === false) || []
      if (temRespostasFalsas.length === 0) {
        return true
      } else {
        return false
      }
    }

    if (pesquisaId && respostas.length !== 0) {
      if (canSubmit()) {
        adicionaRespostasPesquisa({
          variables: {
            pesquisas_disparo_id: pesquisaId,
            curso_id: moduloId || '',
            respostas
          }
        })
      } else {
        enqueueSnackbar('Preencha os campos corretamente.')
      }
    } else {
      enqueueSnackbar('Preencha os campos corretamente.')
    }
  }

  const hasAnyRequired = (perguntas || {}).filter(quest => quest.obrigatorio === true)

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={(hasAnyRequired.length === 0) ? onClose : null}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth={'md'}
        style={{ padding: '25px' }}
      >
        <form noValidate onSubmit={handleSubmit}>
          <DialogWrapper>
            <DialogTitle id="alert-dialog-title">
              <Typography variant={"h4"} component={"h4"} style={{ fontWeight: 300 }}>Pesquisa</Typography>
            </DialogTitle>
            <DialogContent>
              {(perguntas || {}).map((item, index) => {
                return (
                  <>
                    <div style={{ marginBottom: '24px' }}>
                      {item.tipoResposta === '3' && (
                        <>
                          <Typography>{`${item.descricao}`}</Typography>
                          <Typography color='error' style={{ fontSize: '14px', marginLeft: 15 }}>{item.obrigatorio && `*obrigatório` }</Typography>
                          <FormControl error={(item.obrigatorio) ? !answers[index] : false} style={{ display: 'flex' }} >
                            <RadioGroup
                              name={item._id}
                              style={{ marginRight: '5em', flexDirection: 'row' }}
                              value={answers[index]}
                              onChange={(e) => handleChangeAnswers(e, index)}
                            >
                              {item.alternativas.map(row =>
                                <FormControlLabel
                                  control={
                                    <Radio color="primary" />
                                  }
                                  value={row}
                                  label={row}
                                  style={{ marginRight: '5em' }}
                                >
                                </FormControlLabel>
                              )}
                            </RadioGroup>
                            {(item.obrigatorio) ?
                              (!answers[index]) && <FormHelperText>Escolha uma das opções.</FormHelperText>
                              : false}
                          </FormControl>
                        </>
                      )}
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                      {item.tipoResposta === '2' && (
                        <>
                          <Typography >{`${item.descricao}`}</Typography>
                          <Typography color='error' style={{ fontSize: '14px', marginLeft: 15 }}>{item.obrigatorio && `*obrigatório` }</Typography>
                          <div style={{ display: 'flex' }}>
                            <FormControl error={(item.obrigatorio) ? !answers[index] : false}>
                              <FormGroup style={{ marginRight: '5em', flexDirection: 'row' }}>
                                {item.alternativas.map((row, indexAlt) =>
                                  <FormControlLabel
                                    style={{ marginRight: '5em' }}
                                    control={
                                      <Checkbox
                                        checked={((answers[index] || [])[indexAlt] || {}).checked}
                                        onChange={(e) => handleChangeAnswers(e, index, item.tipoResposta, indexAlt)}
                                        name={item._id}
                                        value={row}
                                        color={'primary'}
                                      />
                                    }
                                    label={row}
                                  />
                                )}
                              </FormGroup>
                              {(item.obrigatorio) ?
                                  (!answers[index]) && <FormHelperText>Escolha no mínimo uma opção.</FormHelperText>
                                  : false}
                            </FormControl>
                          </div>
                        </>
                      )}
                    </div>
                    <div>
                      {item.tipoResposta === '1' && (
                        <>
                          <Typography style={{ marginBottom: '16px' }}>{`${item.descricao}`}</Typography>
                          <Typography color='error' style={{ fontSize: '14px', marginLeft: 15 }}>{item.obrigatorio && `*obrigatório` }</Typography>
                          <DialogContentText id="alert-dialog-description" style={{ marginTop: '24px' }}>
                            <TextField
                              id={item._id}
                              error={(item.obrigatorio) ? !answers[index] : false}
                              helperText={(item.obrigatorio) ? 'Escreva a sua resposta.' : false}
                              label="Descrição"
                              fullWidth
                              InputLabelProps={{
                                shrink: true
                              }}
                              onChange={(e) => handleChangeAnswers(e, index)}
                              value={answers[index]}
                              variant="outlined"
                              name={item._id}
                              multiline={true}
                              rows={10}
                            />
                          </DialogContentText>
                        </>
                      )}
                    </div>
                  </>
                )
              })}
            </DialogContent>
            <Divider variant={'fullWidth'} />
            <DialogActions>
              {(hasAnyRequired.length === 0) && (
                <Button type={'button'} onClick={onClose} color="primary">
                  Ignorar
                </Button>
              )}
              <Button type={'submit'} color="primary">
                Responder
              </Button>
            </DialogActions>
          </DialogWrapper>
        </form>
      </Dialog>
    </div>
  );
}
export default ResearchModal